import React, { useState, useEffect } from 'react'
import { Panel, Row, Placeholder, Table } from 'rsuite'
import { isEmpty } from 'lodash'
import OverlayLoader from '../../../../components/OverlayLoader/OverlayLoader'
import { loadLocation } from '../../../../components/location/Location'

export default function ReduceAlcoholBGView({ schema, ...props }) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const { Paragraph } = Placeholder

  const nodataText = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>

  const [singleNganBoon, setSingleNganBoon] = useState([])
  const [joinNganBoon, setJoinNganBoon] = useState([])
  const [location, setLocation] = useState([])
  const [alcoholDrinkProvince, setAlcoholDrinkProvince] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()

    let single = {}
    single[schema.eventSchema.event.name] = <b>{schema.singleNganBoonOtherEvents.label}</b>

    let singleNganBoon = [
      ...schema.singleNganBoon.eventList,
      single,
      ...schema.singleNganBoonOtherEvents.eventList,
    ]

    let join = {}
    join[schema.eventSchema.event.name] = <b>{schema.joinNganBoonOtherEvents.label}</b>

    let joinNganBoon = [
      ...schema.joinNganBoon.eventList,
      join,
      ...schema.joinNganBoonOtherEvents.eventList,
    ]

    // let locationDate = JSON.parse(location)
    // if (schema.alcoholDrinkProvince.value && !isEmpty(location)) {
    //   let alcoholDrinkProvince =
    //     location?.find((obj) => obj.value === schema.alcoholDrinkProvince.value).label || ''
    //   setAlcoholDrinkProvince(alcoholDrinkProvince)
    // }

    setSingleNganBoon(singleNganBoon)
    setJoinNganBoon(joinNganBoon)
  }, [schema])

  useEffect(() => {
    handledSetAlcoholDrinkProvince(schema)
  }, [location])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocation(location)
    setIsLoading(false)
  }

  const handledSetAlcoholDrinkProvince = async (schema) => {
    let location = localStorage.getItem('location')
    let locationData = location ? JSON.parse(location) : []

    if (schema.alcoholDrinkProvince.value && !isEmpty(location)) {
      let alcoholDrinkProvince =
        locationData?.find((obj) => obj.value === schema.alcoholDrinkProvince.value).label || ''
      setAlcoholDrinkProvince(alcoholDrinkProvince)
    }
  }

  return (
    <>
      <Panel header={schema.communityBackground.label}>
        <div>
          <p style={Styles.fontWeightHeader}>{schema.basicInfo.label}</p>
          <ul>
            <li>
              <p>
                {schema.censusHousehold.label}
                <strong>
                  <u>{schema.censusHousehold.value ? schema.censusHousehold.value : nodataText}</u>
                </strong>{' '}
                {schema.censusHousehold.postLabel}
                {schema.realHousehold.label}{' '}
                <strong>
                  <u>{schema.realHousehold.value ? schema.realHousehold.value : nodataText}</u>
                </strong>{' '}
                {schema.realHousehold.postLabel}
              </p>
            </li>
            <li>
              <p>
                {schema.censusPopulation.label}
                <strong>
                  <u>
                    {schema.censusPopulation.value ? schema.censusPopulation.value : nodataText}
                  </u>
                </strong>{' '}
                {schema.censusPopulation.postLabel}
                {schema.realPopulation.label}{' '}
                <strong>
                  <u>{schema.realPopulation.value ? schema.realPopulation.value : nodataText}</u>
                </strong>{' '}
                {schema.realPopulation.postLabel}
              </p>
            </li>
          </ul>
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>
            {schema.alcoholDrink.label}{' '}
            <strong>
              <u>{alcoholDrinkProvince}</u>
            </strong>{' '}
            {schema.ranking.label}{' '}
            <strong>
              <u>{schema.ranking.value}</u>
            </strong>{' '}
          </p>
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.alcoholProblem.label}</p>
          {schema.alcoholProblem.value ? (
            <div
              style={Styles.subContent}
              dangerouslySetInnerHTML={{ __html: schema.alcoholProblem.value }}
            />
          ) : (
            <Paragraph />
          )}
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.alcoholDrinker.label}</p>
          <p style={Styles.subContent}>
            {schema.lowCount.label} {schema.lowCount.value} {schema.lowCount.postLabel}
          </p>

          <p style={Styles.subContent}>
            {schema.normalCount.label} {schema.normalCount.value} {schema.normalCount.postLabel}
          </p>

          <p style={Styles.subContent}>
            {schema.highCount.label} {schema.highCount.value} {schema.highCount.postLabel}
          </p>

          <p style={Styles.subContent}>
            {schema.drinkerDatasource.hint} : {schema.drinkerDatasource.value}
          </p>
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.alcoholShop.label}</p>
          <div style={Styles.subContent}>
            <p>
              {schema.allComplyAct.label} {schema.allComplyAct.preLabel} {schema.allComplyAct.value}{' '}
              {schema.allComplyAct.postLabel}
            </p>
            <p>
              {schema.someComplyAct.label} {schema.someComplyAct.preLabel}{' '}
              {schema.someComplyAct.value} {schema.someComplyAct.postLabel}
            </p>
            <p>
              {schema.neverComplyAct.label} {schema.neverComplyAct.preLabel}{' '}
              {schema.neverComplyAct.value} {schema.neverComplyAct.postLabel}
            </p>
          </div>
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.alcoholDrinkingProblems.label} </p>
          {schema.alcoholDrinkingProblems.value &&
          schema.alcoholDrinkingProblems.value.length > 0 ? (
            <>
              <ul>
                {schema.alcoholDrinkingProblems.value.map((item) => {
                  return (
                    <li key={item}>
                      <p>
                        {schema[item].label} {schema[item].preLabel} {schema[item].value}{' '}
                        {schema[item].postLabel}
                      </p>
                    </li>
                  )
                })}
              </ul>
            </>
          ) : (
            <Paragraph />
          )}
          {schema.alcoholDrinkingDetail.value && (
            <>
              <p style={Styles.fontWeightHeader}>{schema.alcoholDrinkingDetail.label} </p>
              {schema.alcoholDrinkingDetail.value ? (
                <div
                  style={Styles.subContent}
                  dangerouslySetInnerHTML={{ __html: schema.alcoholDrinkingDetail.value }}
                />
              ) : (
                <Paragraph />
              )}
            </>
          )}
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.typeAndNumOfEvent.label} </p>
          <br />
          <p>{schema.joinNganBoon.label}</p>
          <Table bordered cellBordered autoHeight wordWrap headerHeight={105} data={joinNganBoon}>
            <Column minWidth={240} flexGrow={1} align="left" fixed>
              <HeaderCell>
                <div style={{ textAlign: 'center' }}>{schema.eventSchema.event.label}</div>
              </HeaderCell>
              <Cell dataKey={schema.eventSchema.event.name} />
            </Column>

            <Column width={150} align="center">
              <HeaderCell>{schema.eventSchema.totalEvent.label}</HeaderCell>
              <Cell dataKey={schema.eventSchema.totalEvent.name} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>{schema.eventSchema.noAlcoholEvent.label}</HeaderCell>
              <Cell dataKey={schema.eventSchema.noAlcoholEvent.name} />
            </Column>
            <ColumnGroup header={schema.eventSchema.alcoholEvent.label} align="center">
              <Column width={150} colSpan={2}>
                <HeaderCell>
                  {schema.eventSchema.alcoholEvent.preLabel}
                  {schema.eventSchema.alcoholEvent.postLabel}
                </HeaderCell>
                <Cell dataKey={schema.eventSchema.alcoholEvent.name} />
              </Column>

              <Column width={150}>
                <HeaderCell>{schema.eventSchema.totalAlcoholCost.label}</HeaderCell>
                <Cell dataKey={schema.eventSchema.totalAlcoholCost.name} />
              </Column>
            </ColumnGroup>
          </Table>
        </div>

        <div style={Styles.content}>
          <br />
          <p>{schema.singleNganBoon.label}</p>
          <Table bordered cellBordered autoHeight wordWrap headerHeight={105} data={singleNganBoon}>
            <Column minWidth={240} flexGrow={1} align="left" fixed>
              <HeaderCell>
                <div style={{ textAlign: 'center' }}>{schema.eventSchema.event.label}</div>
              </HeaderCell>
              <Cell dataKey={schema.eventSchema.event.name} />
            </Column>

            <Column width={150} align="center">
              <HeaderCell>{schema.eventSchema.totalEvent.label}</HeaderCell>
              <Cell dataKey={schema.eventSchema.totalEvent.name} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>{schema.eventSchema.noAlcoholEvent.label}</HeaderCell>
              <Cell dataKey={schema.eventSchema.noAlcoholEvent.name} />
            </Column>
            <ColumnGroup header={schema.eventSchema.alcoholEvent.label} align="center">
              <Column width={150} colSpan={2}>
                <HeaderCell>
                  {schema.eventSchema.alcoholEvent.preLabel}
                  {schema.eventSchema.alcoholEvent.postLabel}
                </HeaderCell>
                <Cell dataKey={schema.eventSchema.alcoholEvent.name} />
              </Column>

              <Column width={150}>
                <HeaderCell>{schema.eventSchema.totalAlcoholCost.label}</HeaderCell>
                <Cell dataKey={schema.eventSchema.totalAlcoholCost.name} />
              </Column>
            </ColumnGroup>
          </Table>
        </div>

        <div style={Styles.content}>
          <p style={Styles.fontWeightHeader}>{schema.alcoholProblemSolution.label} </p>
          <p style={Styles.subContent}>
            {schema.alcoholProblemSolution.options.map((item) => {
              if (item.value === schema.alcoholProblemSolution.value) {
                return item.label
              }
            })}
          </p>
          {schema.alcoholProblemSolution.value === 'Y' && (
            <>
              <p>{schema.alcoholProblemSubject.label}</p>
              {schema.alcoholProblemSubject.value ? (
                <div
                  style={Styles.subContent}
                  dangerouslySetInnerHTML={{ __html: schema.alcoholProblemSubject.value }}
                />
              ) : (
                <Paragraph />
              )}

              <p>{schema.alcoholProblemSolving.label}</p>
              {schema.alcoholProblemSolving.value ? (
                <div
                  style={Styles.subContent}
                  dangerouslySetInnerHTML={{ __html: schema.alcoholProblemSolving.value }}
                />
              ) : (
                <Paragraph />
              )}

              <p>{schema.alcoholProblemSolveResult.label}</p>
              {schema.alcoholProblemSolveResult.value ? (
                <div
                  style={Styles.subContent}
                  dangerouslySetInnerHTML={{ __html: schema.alcoholProblemSolveResult.value }}
                />
              ) : (
                <Paragraph />
              )}
            </>
          )}

          <p style={Styles.fontWeightHeader}>{schema.strengthWeakness.label}</p>
          {schema.strengthWeakness.value ? (
            <div
              style={Styles.subContent}
              dangerouslySetInnerHTML={{ __html: schema.strengthWeakness.value }}
            />
          ) : (
            <Paragraph />
          )}
        </div>

        <div style={Styles.content}>
          <p style={{ fontWeight: 600 }}>{schema.annualFestival.label}</p>
          <Table
            data={schema.annualFestival.values}
            wordWrap={true}
            bordered
            height={300}
            autoHeight={schema.annualFestival.values.length <= 5}
            style={{ marginTop: '10px' }}
          >
            <Column width={400} align="center" fixed>
              <HeaderCell>{schema.festivalName.label}</HeaderCell>
              <Cell dataKey="festivalName" />
            </Column>

            <Column width={300} align="center">
              <HeaderCell>{schema.festivalDate.label}</HeaderCell>
              <Cell dataKey="festivalDateStr" />
            </Column>
          </Table>
        </div>

        <Row style={Styles.marginTop10}>
          <p>
            &nbsp;&nbsp;&nbsp;{schema.village.label}{' '}
            <u>
              <strong>{schema.village.value} </strong>
            </u>
            {schema.province.label}{' '}
            <u>
              <strong>{schema.addressInfo.provinceName} </strong>
            </u>
            {schema.district.label}{' '}
            <u>
              <strong>{schema.addressInfo.districtName} </strong>
            </u>
            {schema.subDistrict.label}{' '}
            <u>
              <strong>{schema.addressInfo.subDistrictName} </strong>
            </u>
            {schema.footer}
          </p>
        </Row>
        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}

const Styles = {
  content: {
    marginTop: '30px',
  },
  fontWeightHeader: {
    fontWeight: 550,
  },
  subContent: {
    marginLeft: '10px',
    marginTop: '5px',
  },
  marginTop10: {
    marginTop: 10,
  },
}
